import React from "react";
import {
  useGetAllResourcesQuery,
  useDeleteResourcesMutation,
} from "../../store/resourcesApi";
import { Pencil, Trash2 } from "lucide-react";

const AdminAllResources = ({ handleUpdate }) => {
  const { data, isLoading, isError } = useGetAllResourcesQuery();
  const [DeleteResources] = useDeleteResourcesMutation();

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error loading resources.</div>;

  return (
    <div className="p-4 overflow-x-auto">
      <h2 className="text-xl font-bold mb-4">All Resources</h2>
      <table className="min-w-full border border-gray-300 ">
        <thead className="bg-gray-100 dark:bg-background">
          <tr>
            <th className="border p-2">#</th>
            <th className="border p-2">Name</th>
            <th className="border p-2">Title</th>
            <th className="border p-2">Description</th>
            <th className="border p-2 ">Features</th>
            <th className="border p-2">Action</th>
          </tr>
        </thead>
        <tbody>
          {data?.data?.map((item, index) => (
            <tr key={item._id} className="text-center">
              <td className="border p-2">{index + 1}</td>
              <td className="border p-2">{item.name}</td>
              <td className="border p-2">{item.title}</td>
              <td className="border p-2">{item.description}</td>
              <td className="border p-3 align-top">
                <ul className="space-y-4 text-left">
                  {item.features.map((feature) => (
                    <li
                      key={feature._id}
                      className="bg-gray-100 dark:bg-gray-800 p-3 rounded-lg shadow-sm"
                    >
                      <p className="text-sm font-semibold text-gray-800 dark:text-gray-100">
                        {feature.title}
                      </p>
                      <p className="text-sm text-gray-700 dark:text-gray-300">
                        {feature.description}
                      </p>
                      <a
                        href={feature.url}
                        className="text-blue-600 dark:text-blue-400 text-sm underline break-all"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {feature.url}
                      </a>
                    </li>
                  ))}
                </ul>
              </td>

              <td className="border p-2 flex items-center gap-2">
                <button
                  onClick={() => handleUpdate(item)}
                  className="p-1 flex items-center rounded hover:bg-gray-200 dark:hover:bg-gray-700"
                >
                  <Pencil size={18} />
                </button>
                <Trash2
                  size={18}
                  className="text-red-700 cursor-pointer"
                  onClick={() => DeleteResources(item._id)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminAllResources;
